import { EntityModalForm } from "./CRUDs/abstracts/mixins/EntityModalForm";
import { OrganisationCard } from "./CRUDs/entities/OrganisationCard";
import { CardForm } from "./Common/Forms/CardForm";

export default {
    init() {
        this.openPriceDesc();
        this.forceRecetPlan();
        this.acceptPlan();
    },

    openPriceDesc() {
        $('.price__footer-wrapper-box-img').click(function (e){
            $(this).parent().next().toggleClass('price__footer-close');
        });
    },

    forceRecetPlan() {
        $('#force_downgrade').on('click', function() {
            location.href = `/force-downgrade`;
        });
    },

    acceptPlan() {

        const acceptPlanPost = () => {

            $.ajax({
                url: `/accept-plan`,
                type: 'POST'
            })
            .done((result) => {
                $('.bb-preloader-container').hide();
                const formHTML = result.modal;
                EntityModalForm.pasteForm(formHTML);
                $('.modal-backdrop').first().remove();
                $('#success-action-modal').modal('show');
                setTimeout(() => { window.location.reload(); }, 3000);
            })
            .fail((result) => {
                $('.bb-preloader-container').hide();
                const responseJSON = JSON.parse(result.responseText);
                EntityModalForm.pasteForm(responseJSON.modal);
                $('.modal-backdrop').first().remove();
                $('#failed-action-modal').modal('show');
            });

        }



        $("[data-plan-prefetch]").on('click', function(e) {
            e.preventDefault();
            $('.bb-preloader-container').show();
            const url = this.getAttribute('href').split('?').shift();
            const params = new URLSearchParams(this.getAttribute('href').split('?').pop());
            const planId = params.get('plan_id');

            $.ajaxSetup({ data: { plan_id: planId }});

            $.ajax({
                url: url,
                type: 'GET',
                dataType: 'JSON',
            })
            .done(function (response) { acceptPlanPost() })
            .fail(function(response) {
                $('.bb-preloader-container').hide();
                const responseJSON = JSON.parse(response.responseText);
                document.removeEventListener('organisation_card_confirmed', acceptPlanPost );
                document.addEventListener('organisation_card_confirmed', acceptPlanPost );

                if (responseJSON.message === 'card_required') {
                    const staticCard = new OrganisationCard(null,{accept_plan_id:planId});
                    staticCard.openModal('create');
                    //new CardForm(staticCard, 'create')
                } else {
                    const card = new OrganisationCard(responseJSON.card_id, {accept_plan_id:planId});
                    card.openModal('confirm-card');
                    //new CardForm(card, 'confirm-card')
                }
            });
        });
    }

}
